import { motion } from "framer-motion";

interface PageHeaderProps {
  title: string;
  backgroundImage: string;
}

export function PageHeader({ title, backgroundImage }: PageHeaderProps) {
  return (
    <section className="relative h-[25vh] flex items-center">
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.3,
        }}
      />
      <div className="container mx-auto px-4 z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            {title}
          </h1>
        </motion.div>
      </div>
    </section>
  );
} 